<template>
  <div>
    <label for="status" class="mb-1" v-if="!hideLabel">Status</label>
    <multiselect
      id="status"
      v-model="selectedValue"
      trackBy="id"
      label="name"
      placeholder="Select status to search"
      open-direction="bottom"
      :class="className"
      :options="options"
      :multiple="true"
      :searchable="false"
      :internal-search="true"
      :limit="10"
      :max-height="600"
      :show-no-results="false"
      :hide-selected="false"
      @select="onChange($event, 1)"
      @remove="onChange($event, 0)"
      :show-labels="false"
    >
    </multiselect>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
export default {
  components: {
    Multiselect,
  },
  props: {
    value: {
      required: true,
      type: Array,
    },
    hideLabel: {
      required: false,
      type: Boolean,
      default: false,
    },
    className: {
      required: false,
    },
  },
  data() {
    return {
      options: [],
      filter: {
        search: "",
        page: 1,
        take: 5,
      },
      isLoading: false,
      selectedValue: this.value,
    };
  },
  async mounted() {
    this.getList();
  },
  watch: {
    async value(newValue) {
      this.selectedValue = newValue;
    },
  },
  methods: {
    getList: async function () {
      this.isBusy = true;

      const { data } = await this.axios.get(`/ticket/filter/5`);
      if (data.result == 1) {
        this.options = data.detail;
      }
      this.isBusy = false;
    },

    onChange() {
      this.$emit("change", this.selectedValue);
    },
  },
};
</script>

<style lang="scss" scoped></style>
